// Position + street vocabulary. ENGINE_DESIGN.md §1 (schema/position.ts).
import { z } from 'zod';
/** 9-max superset; 6-max is a subset of these seats. Ordered UTG..BB. */
export const POSITION_ORDER = ['UTG', 'UTG1', 'UTG2', 'LJ', 'HJ', 'CO', 'BTN', 'SB', 'BB'];
export const PositionSchema = z.enum(POSITION_ORDER);
export const STREET_ORDER = ['preflop', 'flop', 'turn', 'river'];
export const StreetSchema = z.enum(STREET_ORDER);
/** In-position / out-of-position - the coach-facing positional class (ARCHITECTURE.md §5). */
export const PositionClassSchema = z.enum(['IP', 'OOP']);
//# sourceMappingURL=position.js.map